import React from "react";

export default function () {
    return (
        <React.Fragment>
            <p>&nbsp;</p>
            <h1>Welcome to The Write Class!</h1>
            <p>
                The Write Class is an online first-year writing course placement
                tool that integrates various points of data to create a
                personalized course placement for each student. It integrates
                and analyzes each student's
            </p>
            <ul>
                <li>high school GPA (if applicable);</li>
                <li>writing and reading history;</li>
                <li>preparedness for each course.</li>
            </ul>
            <p>
                It does not allow for multiple attempts, and placement results
                are final. Based on the information you provide in The Write
                Class, you will be placed into Writing and Rhetoric I (ENGL
                111), Writing and Rhetoric I Stretch (ENGL 108/109), Writing and
                Rhetoric I International (ENGL 121), or Writing and Rhetoric II
                (ENGL 112).
            </p>
            <p>
                This process will take between 20-30 minutes. Please be sure you
                have the time to answer all questions before beginning.
            </p>
            <p>
                If you believe you already have credits for one or more of the
                courses listed above, you will receive more detailed information
                about your options at the end of this process.
            </p>
            <p>
                <b>Honor Code Agreement</b>
            </p>
            <p>
                As a member of the Columbia College community, you are obligated
                to abide by our{" "}
                <a
                    href="https://students.colum.edu/handbook/policies/student-code-of-conduct.php"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    student code of conduct
                </a>
                .
            </p>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/columbia-college/siteComponents/auth.js